import { create } from 'zustand';

type TSidebarStore = {
  isSidebarOpen: boolean;
  setIsSidebarOpen: (isSidebarOpen: boolean) => void;
};

/**
 * Used to track global UI state
 */
const useSidebarStore = create<TSidebarStore>(set => ({
  isSidebarOpen: true,
  setIsSidebarOpen: isSidebarOpen => set(() => ({ isSidebarOpen })),
}));

export default useSidebarStore;
